export const applicationData = [
  {
    applicationId: 1,
    status: 'accepted',
    studentInformation: {
      firstNames: 'Olli',
      lastName: 'Opiskelija',
      studentNumber: '1700077',
      email: 'olli.opiskelija@eduix.fi'
    },
    educationInformation: {
      studyType: 'Aikuiskoulutus',
      degreeProgram: 'Ajoneuvotekniikan tutkinto-ohjelma',
      location: '',
      cohort: 'SMXAMK17S',
      specialization: '',
      rightToStudyStart: '01-08-2020',
      rightToStudyEnd: '31-07-2024'
    },
    studyInformation: {
      degreeCredits: 240,
      degreeCreditsRequired: 240,
      semestersUsed: 1,
      semestersSkipped: 0,
      creditsDoneTotal: 0,
      creditsDoneLastYear: 0
    },
    basicInformation: {
      decisionDate: '2022-12-15',
      decisionResult: 'approved',
      submitted_at: '2022-12-10 12:36',
      updated_at: '2022-12-12 12:36',
      studyRightExtensionTimePeriod: '01-01-2023 - 31-12-2023',
      reasonForDelayedStudies: 'Selvitys',
      tutorName: 'Oili Ohjaaja',
      tutoringDate: '28-11-2022',
      stateOfThesis: 'Ei suunnitelmaa',
      thesisPlan: 'Ei hyväksytty',
      attachments: ''
    },

    messages: [
      {
        messageId: 1,
        sender: 'Teppo Testaaja',
        sendTime: '03-12-2022 17:25:31',
        messageTopic: 'Viesti Käsittelijältä',
        messageText: 'Viesti'
      },
      {
        messageId: 2,
        sender: 'Teppo Testaaja',
        sendTime: '04-06-2023 17:27:31',
        messageTopic: 'Viesti Käsittelijältä',
        messageText: 'Toinen viesti'
      }
    ],
    handlingMessages: [
      {
        messageId: 1,
        processId: 1,
        orderIndex: 1,
        stage: 'application',
        status: 'Tehty',
        name: 'Olli Opiskelija',
        time: '08-12-2022 12:36:00'
      },
      {
        messageId: 2,
        processId: 1,
        orderIndex: 2,
        stage: 'processing',
        status: 'Tehty',
        name: 'Ville Virkailija',
        time: '09-12-2022 12:36:00'
      },
      {
        messageId: 3,
        processId: 1,
        orderIndex: 3,
        stage: 'registering',
        status: 'Tehty',
        name: 'Rauni Rekisteröijä',
        time: '10-12-2022 12:36:00'
      }
    ],
    missingStudies: [
      {
        name: 'Testirivi 1',
        code: 'TEST-0001',
        credits: '5',
        plannedCourseTime: '01-08-2023',
        status: 'Hyvin suunniteltu'
      },
      {
        name: 'Testirivi 2',
        code: 'TEST-0002',
        credits: '10',
        plannedCourseTime: '15-10-2023',
        status: 'Kesken'
      }
    ]
  },
  {
    applicationId: 2,
    status: 'accepted',
    studentInformation: {
      firstNames: 'Esko',
      lastName: 'Epäkesko',
      studentNumber: '1234321',
      email: 'esko.epakesko@eduix.fi'
    },
    educationInformation: {
      studyType: 'Aikuiskoulutus',
      degreeProgram: 'Ajoneuvotekniikan tutkinto-ohjelma',
      location: '',
      cohort: 'SMXAMK17S',
      specialization: '',
      rightToStudyStart: '01-08-2020',
      rightToStudyEnd: '31-07-2024'
    },
    studyInformation: {
      degreeCredits: 240,
      degreeCreditsRequired: 240,
      semestersUsed: 1,
      semestersSkipped: 0,
      creditsDoneTotal: 0,
      creditsDoneLastYear: 0
    },
    basicInformation: {
      decisionDate: '2022-12-08',
      decisionResult: 'accepted',
      submitted_at: '2022-12-01 12:36',
      updated_at: '2022-12-08 12:36',
      studyRightExtensionTimePeriod: '01-01-2023 - 31-12-2023',
      reasonForDelayedStudies: 'Selvitys',
      tutorName: 'Oili Ohjaaja',
      tutoringDate: '28-11-2022',
      stateOfThesis: 'Ei suunnitelmaa',
      thesisPlan: 'Ei hyväksytty',
      attachments: ''
    },

    messages: [
      {
        messageId: 1,
        sender: 'Teppo Testaaja',
        sendTime: '03-12-2022 17:25:31',
        messageTopic: 'Viesti Käsittelijältä',
        messageText: 'Viesti'
      },
      {
        messageId: 2,
        sender: 'Teppo Testaaja',
        sendTime: '04-06-2023 17:27:31',
        messageTopic: 'Viesti Käsittelijältä',
        messageText: 'Toinen viesti'
      }
    ],
    handlingMessages: [
      {
        messageId: 1,
        processId: 1,
        orderIndex: 1,
        stage: 'application',
        status: 'Tehty',
        name: 'Olli Opiskelija',
        time: '08-12-2022 12:36:00'
      },
      {
        messageId: 2,
        processId: 1,
        orderIndex: 2,
        stage: 'processing',
        status: 'Tehty',
        name: 'Ville Virkailija',
        time: '09-12-2022 12:36:00'
      },
      {
        messageId: 3,
        processId: 1,
        orderIndex: 3,
        stage: 'registering',
        status: 'Tehty',
        name: 'Rauni Rekisteröijä',
        time: '10-12-2022 12:36:00'
      }
    ],
    missingStudies: [
      {
        name: 'Testirivi 1',
        code: 'TEST-0001',
        credits: '5',
        plannedCourseTime: '01-08-2023',
        status: 'Hyvin suunniteltu'
      },
      {
        name: 'Testirivi 2',
        code: 'TEST-0002',
        credits: '10',
        plannedCourseTime: '15-10-2023',
        status: 'Kesken'
      }
    ]
  },
  {
    applicationId: 3,
    status: 'submitted',
    studentInformation: {
      firstNames: 'Keijo',
      lastName: 'Kekkula',
      studentNumber: '5675674',
      email: 'keijo.kekkula@eduix.fi'
    },
    educationInformation: {
      studyType: 'Aikuiskoulutus',
      degreeProgram: 'Ajoneuvotekniikan tutkinto-ohjelma',
      location: '',
      cohort: 'SMXAMK17S',
      specialization: '',
      rightToStudyStart: '01-08-2020',
      rightToStudyEnd: '31-07-2023'
    },
    studyInformation: {
      degreeCredits: 240,
      degreeCreditsRequired: 240,
      semestersUsed: 1,
      semestersSkipped: 0,
      creditsDoneTotal: 0,
      creditsDoneLastYear: 0
    },
    basicInformation: {
      decisionDate: '',
      decisionResult: '',
      submitted_at: '2023-05-08 12:36',
      updated_at: '2023-06-10 12:36',
      studyRightExtensionTimePeriod: '01-01-2023 - 31-12-2023',
      reasonForDelayedStudies: 'Selvitys',
      tutorName: 'Oili Ohjaaja',
      tutoringDate: '28-11-2022',
      stateOfThesis: 'Ei suunnitelmaa',
      thesisPlan: 'Ei hyväksytty',
      attachments: ''
    },

    messages: [
      {
        messageId: 1,
        sender: 'Teppo Testaaja',
        sendTime: '03-12-2022 17:25:31',
        messageTopic: 'Viesti Käsittelijältä',
        messageText: 'Viesti'
      }
    ],
    handlingMessages: [
      {
        messageId: 1,
        processId: 1,
        orderIndex: 1,
        stage: 'application',
        status: 'Tehty',
        name: 'Olli Opiskelija',
        time: '08-12-2022 12:36:00'
      },
      {
        messageId: 2,
        processId: 1,
        orderIndex: 2,
        stage: 'processing',
        status: 'Tehty',
        name: 'Ville Virkailija',
        time: '09-12-2022 12:36:00'
      },
      {
        messageId: 3,
        processId: 1,
        orderIndex: 3,
        stage: 'registering',
        status: 'Tehty',
        name: 'Rauni Rekisteröijä',
        time: '10-12-2022 12:36:00'
      }
    ],
    missingStudies: [
      {
        name: 'Testirivi 1',
        code: 'TEST-0001',
        credits: '5',
        plannedCourseTime: '01-08-2023',
        status: 'Hyvin suunniteltu'
      },
      {
        name: 'Testirivi 2',
        code: 'TEST-0002',
        credits: '10',
        plannedCourseTime: '15-10-2023',
        status: 'Kesken'
      }
    ]
  }
];
